module.exports = __webpack_public_path__ + "static/img/img06@2x.876aacf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app/instructions/img06@2x.png
// module id = os4f
// module chunks = 174